export default class FormaPagamento {
  constructor(public codigo = "", public nome = "") {}
}
